import { createFileRoute } from "@tanstack/react-router"

import { PageContent } from "@/components/common/page-content"
import { PageHeader } from "@/components/common/page-header"
import { SendReviewButton } from "@/features/reviews/components/send-review-button"
import { SubjectReviews } from "@/features/reviews/components/subject-reviews"
import { reviewQueries } from "@/queries/reviews"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId/reviews/"
)({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      reviewQueries.list({ individual_id: params.individualId })
    ),
  component: IndividualReviewsPage,
})

function IndividualReviewsPage() {
  const { individualId } = Route.useParams()

  return (
    <>
      <PageHeader
        title="Reviews"
        actions={<SendReviewButton individualId={individualId} />}
      />
      <PageContent>
        <SubjectReviews filters={{ individual_id: individualId }} />
      </PageContent>
    </>
  )
}
